import { rasterizeElement } from '@/shared/lib/rasterizeElement';

const MAX_DPR = 1.5; // CyberGridGL 과 같은 상한

export interface PreparedPanel {
  /** 지금 화면에서 모달이 있는 자리에 찍어 둔 그림을 놓은, 화면 크기 캔버스 */
  place(): HTMLCanvasElement | null;
}

/**
 * 접속 승인 모달을 지금 모습 그대로 찍어 둔다. 찍는 동안 화면이 100ms 넘게 멈추므로(2026-09-28 실측
 * 최대 133ms) 넘기기 전에 미리 찍고, 넘길 때는 place() 로 자리만 맞춰 베일 텍스처로 넘긴다 —
 * DOM 모달은 WebGL 베일과 함께 접을 수 없어서 그림으로 옮긴다. 찍지 못하면(브라우저가 막음) null.
 */
export async function preparePanelForVeil(panel: HTMLElement): Promise<PreparedPanel | null> {
  const rect0 = panel.getBoundingClientRect();
  const layoutWidth = parseFloat(getComputedStyle(panel).width);
  if (!(rect0.width > 0 && layoutWidth > 0)) return null;
  const dpr = Math.min(window.devicePixelRatio || 1, MAX_DPR);
  // 화면에서 줄어(zoom) 보이는 만큼 찍는 해상도도 맞춘다
  const shot = await rasterizeElement(panel, (dpr * rect0.width) / layoutWidth);
  if (!shot) return null;

  return {
    place() {
      const rect = panel.getBoundingClientRect();
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(window.innerWidth * dpr);
      canvas.height = Math.round(window.innerHeight * dpr);
      const g = canvas.getContext('2d');
      if (!g) return null;
      g.drawImage(shot, rect.left * dpr, rect.top * dpr, rect.width * dpr, rect.height * dpr);
      return canvas;
    },
  };
}
